<div class="photographer-list-item">
  @if (photographer) {
    <div class="photographer-list-item__photo">
      @if (photographer.image) {
        <app-image
          [src]="photographer.image"
          [alt]="photographer.firstname || 'Photographer'"
          preset="card"
          aspectRatio="1/1"
          [width]="240"
          [height]="240"
        ></app-image>
      }
    </div>
    <div class="photographer-list-item__name">
      <p>{{photographer.firstname}}</p>
      @if (photographer.certified) {
        <div
          class="photographer-list-item__certification-container"
          #certificationContainer
          (mouseenter)="showCertificationModal()"
          (mouseleave)="hideCertificationModal()"
        >
          <div class="photographer-list-item__certification">
            <i class="fa-solid fa-certificate"></i>
            <i class="fa-solid fa-check"></i>
          </div>

          <div
            #certificationModal
            class="photographer-list-item__certification-modal"
            [class.is-visible]="certificationModalVisible"
            [style.--cert-modal-offset-x.px]="certificationModalOffset"
          >
            <p>{{'marketplace.search.photographer.certified'|transloco}}</p>
          </div>
        </div>
      }
    </div>
    <div class="photographer-list-item__tags">
      <div class="photographer-tag">
        <i class="fa-solid fa-camera-retro"></i>
        <p>{{'marketplace.search.photographer.services'|transloco: {count: photographer.services.length} }}</p>
      </div>
      @if (photographer.city) {
        <div class="photographer-tag">
          <i class="fa-solid fa-tree-city"></i>
          <p>{{photographer.city|titlecase}}</p>
        </div>
      }
    </div>
  }

  @if (!photographer) {
    <div class="photographer-list-item__photo skeleton-loading"></div>
    <div class="photographer-list-item__name skeleton-loading"></div>
  }
</div>
